__webpack_require__.p = "https://ikea.marat.qd.je/jp/ja/customer-service/support/";